import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'lowerCaseSpecificWords',
  standalone: true
})
export class LowerCaseSpecificWordsPipe implements PipeTransform {

  transform(str: string): string {
    const arr = str?.split(" ");

    const excludedWords = ["a", "an", "the", "for", "with", "about", "at", "in", "to", "on", "after", "so", "that"];

    const intersection = arr?.filter(x => excludedWords.includes(x));

    if (intersection?.length > 0) {
      for (let i = 0; i < arr.length; i++) {
        if (excludedWords.includes(arr[i])) {
          arr[i] = arr[i].toLowerCase();
        } else {
          arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
        }
      }
    } else {
      for (let i = 0; i < arr.length; i++) {
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
      }
    }
    return arr.join(" ");
  }

}
